import type { ResponseWithType, AwardsResponseRest, AwardsResponse } from './types';

const awardsResponse = ({ data }: ResponseWithType<AwardsResponseRest>): AwardsResponse => {
  return {
    ...data,
    __typename: 'AwardsResponse',
    awards: data.awards.map((award) => ({
      ...award,
      id: award.awardId,
      __typename: 'Award',
    })),
  };
};

export default awardsResponse;
